import script from "./DemmandView.vue?vue&type=script&setup=true&lang=js"
export * from "./DemmandView.vue?vue&type=script&setup=true&lang=js"

import "./DemmandView.vue?vue&type=style&index=0&id=50d68036&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50d68036"]])

export default __exports__